import React, { useState, useEffect } from "react";
import { ArrowRight, CheckCircle2, CreditCard, Smartphone, Building2, ShieldCheck, Zap, BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [transactionStep, setTransactionStep] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setTransactionStep(prev => (prev + 1) % 4);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  const stats = [{
    icon: CreditCard,
    text: "Dijital Gülüş Tasarımı"
  }, {
    icon: Zap,
    text: "Biyouyumlu Materyal"
  }, {
    icon: BarChart3,
    text: "Ömür Boyu Destek"
  }];
  const paymentMethods = [{
    name: "Doğal Görünüm",
    icon: Smartphone,
    color: "bg-primary"
  }, {
    name: "Yüksek Dayanıklılık",
    icon: CreditCard,
    color: "bg-primary/80"
  }, {
    name: "Hızlı Uygulama",
    icon: Building2,
    color: "bg-primary/60"
  }];
  return <section data-section-id="39090" id="zirkonyum-kaplama-hero" ref={ref} className="relative min-h-[90vh] w-full overflow-hidden bg-background text-foreground flex items-center pt-20 pb-20 lg:pt-32 lg:pb-32">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--accent)_0%,_var(--background)_100%)] z-0" />
      
      {}
      <div className="absolute inset-0 opacity-20 z-0 pointer-events-none" style={{
      backgroundImage: "radial-gradient(var(--primary) 1px, transparent 1px)",
      backgroundSize: "60px 60px",
      maskImage: "linear-gradient(to bottom, black 40%, transparent 100%)"
    }} />

      {}
      <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-primary rounded-full blur-[120px] opacity-10 animate-pulse" />
      <div className="absolute bottom-[-10%] left-[-5%] w-80 h-80 bg-accent rounded-full blur-[100px] opacity-10" />

      <div className="container relative z-10 mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
        
        {}
        <div className={`space-y-8 transition-all duration-1000 transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-sm bg-primary/10 backdrop-blur-sm border border-primary/20 text-sm font-medium text-primary shadow-sm">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary"></span>
            </span>
            Doğal ve Estetik Bir Gülüş
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-[84px] font-bold font-serif leading-[1.1] tracking-widest text-primary drop-shadow-sm">
            Zirkonyum <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-[#b08d57] drop-shadow-none">Kaplama</span>
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-xl leading-relaxed font-sans">
            En yüksek kalitede zirkonyum materyallerle, doğal diş yapınıza en yakın estetik ve dayanıklılığı sunuyoruz.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <Button asChild size="lg" className="bg-gradient-to-br from-primary to-[#b08d57] hover:opacity-90 text-primary-foreground border-none shadow-lg transition-all duration-300 transform hover:-translate-y-1 text-base font-semibold px-8 h-14 rounded-sm cursor-pointer">
              <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab>
                Hemen Randevu Al
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="bg-transparent border-primary/30 text-primary hover:bg-primary/5 hover:border-primary/50 backdrop-blur-sm transition-all duration-300 text-base font-medium px-8 h-14 rounded-sm cursor-pointer">
              
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-primary/20">
            {stats.map((stat, i) => <div key={i} className="flex items-center gap-3" data-index={i}>
                <div className="p-2 rounded-sm bg-primary/10 text-primary shrink-0">
                  <stat.icon className="h-5 w-5" />
                </div>
                <span className="text-sm font-medium text-muted-foreground leading-tight">{stat.text}</span>
              </div>)}
          </div>
        </div>

        {}
        <div className={`relative perspective-1000 transition-all duration-1000 delay-300 transform ${isVisible ? "translate-x-0 opacity-100 blur-0" : "translate-x-10 opacity-0 blur-sm"}`}>
          {}
          <div className="absolute -top-12 -right-12 w-64 h-64 bg-gradient-to-br from-primary/20 to-transparent opacity-30 rounded-full blur-3xl" />
          
          <Card className="relative bg-card/50 backdrop-blur-xl border border-border shadow-2xl overflow-hidden rounded-sm transform rotate-y-[-5deg] hover:rotate-y-0 transition-transform duration-500">
            <CardHeader className="border-b border-border pb-4 pt-6 px-6">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <div className="h-3 w-3 rounded-full bg-primary/40" />
                  <div className="h-3 w-3 rounded-full bg-primary/60" />
                  <div className="h-3 w-3 rounded-full bg-primary/80" />
                </div>
                <div className="text-xs font-mono text-primary/70 bg-primary/5 px-3 py-1 rounded-sm border border-primary/10">
                  estetik.analiz/zirkonyum
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-6 space-y-6">
              <div className="text-center space-y-1 py-2">
                <p className="text-sm text-muted-foreground font-medium uppercase tracking-widest">Estetik Analiz</p>
                <h3 className="text-4xl font-serif font-bold text-primary tracking-tight">Kusursuz</h3>
              </div>

              <div className="space-y-3">
                {paymentMethods.map((method, idx) => <div key={idx} data-index={idx} className={`flex items-center justify-between p-3.5 rounded-sm border transition-all duration-300 ${transactionStep === idx ? "bg-primary/10 border-primary shadow-sm scale-[1.02]" : "bg-background/50 border-border opacity-70"}`}>
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-sm ${method.color} text-primary-foreground shadow-sm`}>
                        <method.icon className="h-4 w-4" />
                      </div>
                      <span className="font-medium text-foreground">{method.name}</span>
                    </div>
                    {transactionStep === idx && <div className="h-2.5 w-2.5 rounded-full bg-primary animate-pulse shadow-[0_0_8px_var(--primary)]" />}
                  </div>)}
              </div>

              <div className="pt-4 border-t border-border">
                <div className={`flex items-center justify-center gap-2 p-3 rounded-sm transition-all duration-500 ${transactionStep === 3 ? "bg-primary/20 text-primary border border-primary/30" : "bg-muted text-muted-foreground border border-border"}`}>
                  {transactionStep === 3 ? <>
                      <CheckCircle2 className="h-5 w-5" />
                      <span className="font-semibold">Gülüşünüz Hazır</span>
                    </> : <>
                      <div className="h-4 w-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
                      <span className="font-medium">Tasarım hazırlanıyor...</span>
                    </>}
                </div>
              </div>
            </CardContent>
          </Card>

          {}
          <div className="absolute -bottom-6 -left-6 bg-card text-foreground p-4 rounded-sm shadow-xl flex items-center gap-3 animate-bounce duration-[3000ms] z-20 max-w-[220px] border border-border backdrop-blur-md">
            <div className="bg-primary/10 p-2.5 rounded-sm text-primary shrink-0">
              <ShieldCheck className="h-6 w-6" />
            </div>
            <div>
              <p className="text-[10px] font-bold text-primary uppercase tracking-widest">ESTETİK</p>
              <p className="font-bold text-sm leading-tight font-serif">Natural Aesthetics</p>
            </div>
          </div>
        </div>

      </div>
    </section>;
}